import { connect } from 'react-redux';
import { getContinents } from '../../../../app/continents/continents.actions';
import {
  syncLocationValue,
  syncStrictLocation,
  syncHoursOverlap,
} from '../../../../app/job-creation/job-creation.actions';
import { LocationAndHoursOverlap } from './location-hours-overlap';

const mapStateToProps = state => {
  return {
    isStrictLocation: state.jobCreation.location.isStrict,
    location: state.jobCreation.location.value,
    continents: state.continents.continents,
    showError: state.jobCreation.showValidationErrors,
    jobCreationId: state.jobCreation.id,
    hoursOverlap: state.jobCreation.hoursOverlap,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleLocationChange: location => {
      dispatch(syncLocationValue(location));
    },
    handleLocationToggle: isStrict => {
      dispatch(syncStrictLocation(isStrict));
    },
    getContinents: () => {
      dispatch(getContinents());
    },
    handleHoursOverlapChange: hoursOverlap => {
      dispatch(syncHoursOverlap(hoursOverlap));
    },
  };
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LocationAndHoursOverlap);
export { connected as LocationAndHoursOverlapContainer };
